import {
  PersonOutline,
  ScaleOutlined,
  NotificationsActive,
  ApartmentOutlined,
} from '@mui/icons-material';

import { useSelector } from 'react-redux';
import React, { useState } from 'react';
import {
  Tabs,
  TabsList,
  TabsTrigger,
  TabsContent,
  PageHeader,
} from 'lift-ui';
import { AdminLogsPage } from '../admin-logs';

const options = [
  {
    container: 'brands',
    option: 'Brands',
    icon: <ApartmentOutlined />,
  },
  {
    container: 'br-wt',
    option: 'Brand Weights',
    icon: <ScaleOutlined />,
  },
  {
    container: 'users-internal',
    option: 'Users',
    icon: <PersonOutline />,
  },
  {
    container: 'notification-teams',
    option: 'notification-teams',
    icon: <NotificationsActive />,
  },
];

const OverView = ({ setContainer }: { setContainer: any }) => {
  const { superAdmin } = useSelector((state: any) => state.admin);
  const [toggle, setToggle] = useState<string>('dashboard');

  return (
    <div className="flex flex-col h-full bg-white">
      {/* Page Header */}
      {toggle !== 'activity-logs' && (
        <PageHeader
          tabs={[]}
          title="Overview"
        />
      )}

      {/* Main Content */}
      <div className="flex-1 overflow-hidden flex flex-col min-w-0 px-4 lg:px-6 py-6">
        {superAdmin ? (
          <Tabs
            value={toggle}
            onValueChange={(value) => setToggle(value)}
            className="flex-1 flex flex-col min-h-0"
          >
            {/* Tabs Header */}
            <div className="mb-4">
              <TabsList className="grid grid-cols-2 w-fit">
                <TabsTrigger value="dashboard">Dashboard</TabsTrigger>
                <TabsTrigger value="activity-logs">Activity Logs</TabsTrigger>
              </TabsList>
            </div>

            {/* Dashboard Tab Content */}
            <TabsContent value="dashboard" className="flex-1 flex flex-col min-h-0 mt-0">
              <div className="flex-1 flex flex-col bg-white min-h-0 rounded-lg shadow-sm p-8">
                <div className="heading mb-8">
                  <div className="head-title flex items-center gap-4 mb-2">
                    <img alt="lift" src={'/assets/lift-logo.png'} className="h-12" />
                    <h1 className="text-2xl font-semibold text-gray-900">Welcome to LIFT Admin Panel</h1>
                  </div>
                  <p className="text-gray-600">Partnership Performance Analytics SaaS Platform</p>
          </div>
          <div className="body">
                  <h2 className="text-lg font-semibold text-gray-900 mb-4">Quick Access</h2>
            <div
                    className="quick-access grid gap-4"
              style={{
                gridTemplateColumns: superAdmin
                        ? 'repeat(4, minmax(0, 1fr))'
                        : 'repeat(3, minmax(0, 1fr))',
                    }}
                  >
              {options.map((o, i) => {
                if (
                  !superAdmin &&
                  (o.container === 'organization' ||
                    o.container === 'admins' ||
                    o.container === 'cms' ||
                    o.container === 'payments')
                ) {
                        return null;
                } else if (superAdmin && o.container === 'admin-profile') {
                        return null;
                }
                return (
                  <div
                    key={i}
                    onClick={() => {
                      setContainer(o.container);
                    }}
                          className="quick-grid cursor-pointer bg-white border border-gray-200 rounded-lg p-6 hover:border-[#334238] hover:shadow-md transition-all"
                        >
                          <div className="content-box flex flex-col items-center gap-3">
                            <div className="text-[#334238]">{o.icon}</div>
                            <p className="text-sm font-medium text-gray-700">{o.option}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
            </TabsContent>

            {/* Activity Logs Tab Content */}
            <TabsContent value="activity-logs" className="flex-1 flex flex-col min-h-0 min-w-0 mt-0 overflow-hidden">
              <AdminLogsPage />
            </TabsContent>
          </Tabs>
        ) : (
          // Non-superAdmin view - just show dashboard
          <div className="flex-1 flex flex-col bg-white min-h-0 rounded-lg shadow-sm p-8">
            <div className="heading mb-8">
              <div className="head-title flex items-center gap-4 mb-2">
                <img alt="lift" src={'/assets/lift-logo.png'} className="h-12" />
                <h1 className="text-2xl font-semibold text-gray-900">Welcome to LIFT Admin Panel</h1>
              </div>
              <p className="text-gray-600">Partnership Performance Analytics SaaS Platform</p>
            </div>
            <div className="body">
              <h2 className="text-lg font-semibold text-gray-900 mb-4">Quick Access</h2>
              <div
                className="quick-access grid gap-4"
          style={{
                  gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
                }}
              >
                {options.map((o, i) => {
                  if (
                    !superAdmin &&
                    (o.container === 'organization' ||
                      o.container === 'admins' ||
                      o.container === 'cms' ||
                      o.container === 'payments')
                  ) {
                    return null;
                  }
                  return (
                    <div
                      key={i}
                      onClick={() => {
                        setContainer(o.container);
                      }}
                      className="quick-grid cursor-pointer bg-white border border-gray-200 rounded-lg p-6 hover:border-[#334238] hover:shadow-md transition-all"
                    >
                      <div className="content-box flex flex-col items-center gap-3">
                        <div className="text-[#334238]">{o.icon}</div>
                        <p className="text-sm font-medium text-gray-700">{o.option}</p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
        </div>
      )}
      </div>
    </div>
  );
};

export default OverView;
